import types from '../../actions.types';
import { getUser } from '../../../api-calls/user/user'

const { PENDING, SUCCESS, FAILED } = types.user;

export default () => {

  return dispatch => {

    dispatch({ type: PENDING });

    getUser().then(data => {
      dispatch({
        type: SUCCESS,
        data
      });
    }).catch(error => {
      dispatch({
        type: FAILED,
        error
      });
    });

  }
}

